import { Component, OnInit , ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { LocationService } from "../shared/location.service";

@Component({
  selector: 'app-locationlist',
  templateUrl: './locationlist.component.html',
  styleUrls: ['./locationlist.component.css']
})
export class LocationlistComponent implements OnInit {

  displayedColumns: string[] = ['LocationId','LocationName', 'Type', 'New'];
  ChequeList$ = [''];
  dataSource = new MatTableDataSource<any>();
 @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;


  constructor(private router: Router, private locationService: LocationService) { 

   
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }
  
  ngOnInit() {  
    this.getLocationList();
    this.dataSource.paginator = this.paginator;
}

getLocationList() {
  this.locationService.FetchLocationList().subscribe(data => {
    // this.ChequeList$=data;
    this.dataSource.data = data;
  })
}

public AddNewLocation() {
  this.router.navigate(['/location']);
}

EditLocation(Location: any) {
  this.router.navigate(['/location', Location.Id]);
}



}
